module.exports = __webpack_public_path__ + "static/media/magnet.29aa01ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/magnet.svg
// module id = 1193
// module chunks = 71